import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = { class: "btn btn-link btn-sm" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { key: 1 }

import { ref, computed, watch, onMounted } from 'vue'
    import { useRoute } from 'vue-router'
    import { useUserAccessRequestsPage } from '@Organizations/Users/pages-core'
    import AdminNavigationV2 from "@common/AdminNavigationV2.vue";
    import UsersTable from "@Organizations/Users/Components/UsersTable.vue";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UserAccessRequestsRejectedPage',
  setup(__props) {

    const id = parseInt(useRoute().params.id)

    const { useUserAccessRequestsQuery } = useUserAccessRequestsPage()
    const { modelUserAccessRequestsQueryV1, runUserAccessRequestsQueryV1 } = useUserAccessRequestsQuery(id, false, true)
    const rejected = computed(() => modelUserAccessRequestsQueryV1.value?.Rejected || [])

    onMounted(() => {
        document.title = 'Rejected user access requests'
        runUserAccessRequestsQueryV1()
    })

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: _unref(id) }, null, 8 /* PROPS */, ["tid"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }, "Rejected user access requests", -1 /* CACHED */)),
          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_5, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", {
              class: "fa fa-users",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Pending requests ", -1 /* CACHED */)
          ]))])), [
            [_directive_sanitizedHref, `/#/admin/organizations/users/requests/${_unref(id)}`]
          ])
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-lg-5 col-sm-6 text-right" }, null, -1 /* CACHED */))
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_6, [
      (rejected.value.length)
        ? (_openBlock(), _createBlock(UsersTable, {
            key: 0,
            users: rejected.value,
            showActive: false
          }, null, 8 /* PROPS */, ["users"]))
        : (_openBlock(), _createElementBlock("h4", _hoisted_7, "No rejected access requests"))
    ])
  ]))
}
}

})